import React, { useEffect, useRef, useState, ReactNode } from 'react'
import { IDataDisplayer } from './DataDisplayer'
import { Checkbox } from '@mui/material'
import { useDispatch } from 'react-redux'
import { toggleDisplayerColumn } from './dataDisplyerSlice'

interface IProps {
    title?: string
    shown?: boolean,
    hideModal: () => void,
    children: ReactNode,
}

const DataDisplayerOptionsModal: React.FC<IProps> = ({ children, ...props }) => {

    const dispatch = useDispatch()

    const { title, shown, hideModal } = props

    const baseContainerClassName: string = "data-displayer-options-modal"
    const [containerClassName, setContainerClassName] = useState<string>(baseContainerClassName)

    const menuRef = useRef<HTMLDivElement | null>(null);
  
    // Close menu if clicked outside
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            hideModal()
        }
      };
  
      document.addEventListener("mousedown", handleClickOutside);
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    useEffect(() => {
        if (shown){
            setContainerClassName(baseContainerClassName + " active")
        }else{
            setContainerClassName(baseContainerClassName)
        }
    }, [shown])

    return(
        <div className={containerClassName} ref={menuRef}>

            {title && (
                <div className="title-of-data-displayer-options-modal">
                    <div className="content-of-title-of-data-displayer-options-modal">
                        <h3>{title}</h3>
                    </div>
                </div>
            )}

            <div className="content-of-data-displayer-options-modal">
                {children}
            </div>

        </div>
    )
}

export default DataDisplayerOptionsModal